module.exports = __webpack_public_path__ + "static/media/barbara2.c4cb6314.mp3";